// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/NotoNastaliqUrdu-Regular.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Noto Nastaliq Urdu — self-hosted (SIL Open Font License, see src/assets/fonts/OFL.txt).
   Applied only in Urdu mode via the dir="rtl" attribute i18n.js sets on <html>. */
@font-face {
  font-family: 'Noto Nastaliq Urdu';
  font-style: normal;
  font-weight: 400 700;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2');
  unicode-range: U+0600-06FF, U+0750-077F, U+0870-088E, U+0890-0891, U+0897-08E1, U+08E3-08FF,
    U+200C-200E, U+2010-2011, U+204F, U+2E41, U+FB50-FDFF, U+FE70-FE74, U+FE76-FEFC;
}

/* MUI sets font-family per-component with class-selector specificity, so a plain
   inherited rule here would lose that tie unpredictably by stylesheet order —
   !important guarantees Urdu mode always wins, scoped so English mode is untouched. */
html[dir="rtl"] * {
  font-family: 'Noto Nastaliq Urdu', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI',
    'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif !important;
}

/* Nastaliq's tall ascenders get clipped inside small Chips — not by the
   Chip's own padding, but by its inner .MuiChip-label span, which MUI gives
   \`overflow: hidden; white-space: nowrap\` by default for text truncation.
   Padding here is matched to MUI's default small Button (4px 10px) — the
   "تفصیلات" button in the Actions column, which was never clipped and looks
   right — so every chip in the row ends up the same visual size as that
   reference instead of a mix of oversized/undersized pills. Opt-in via
   .nastaliq-chip-padding (added only to the specific Chips that showed
   clipping in PermitList.js) so other Chips elsewhere are untouched. */
html[dir="rtl"] .nastaliq-chip-padding {
  padding: 4px 10px !important;
  height: 32px !important;
  box-sizing: border-box !important;
  display: inline-flex !important;
  align-items: center !important;
}

/* Chips with a leading icon (e.g. the History clock icon) otherwise end up
   visibly bigger than plain-text chips because MUI adds its own icon margin
   on top of our padding — tighten that margin so icon vs. no-icon chips
   match. Height is locked above so content (icon or not) can no longer
   change the chip's size. */
html[dir="rtl"] .nastaliq-chip-padding .MuiChip-icon {
  margin-inline: 4px !important;
  font-size: 1.1rem !important;
}

html[dir="rtl"] .nastaliq-chip-padding .MuiChip-label {
  overflow: visible !important;
  white-space: nowrap !important;
  line-height: 1.8 !important;
  padding: 0 !important;
}

/* Same root cause as the Chip fix above, but for MUI TextField/Select
   floating labels (the small caption above each filter dropdown) — MUI
   clips them with \`overflow: hidden\` by default, cutting Nastaliq's tall
   ascenders. Applied app-wide in RTL mode since every TextField label uses
   the same structure. */
html[dir="rtl"] .MuiInputLabel-root {
  overflow: visible !important;
  line-height: 1.6 !important;
}

/* Same root cause again, this time for chart card titles (e.g. Reports.js's
   CardHeader above each chart) — MUI's CardHeader title has tight default
   line-height, and the tall Nastaliq ascenders poke out above the header's
   own padding box. Since the header sits inside a Card with overflow:hidden
   (for its rounded corners), that overflow area gets clipped instead of just
   the header background, cropping the top of the Urdu heading. Extra
   padding-top plus a taller line-height keeps the glyph fully inside the
   header's own box so the Card's overflow never has to clip it. */
html[dir="rtl"] .MuiCardHeader-root {
  padding-top: 16px !important;
}

html[dir="rtl"] .MuiCardHeader-title {
  line-height: 1.8 !important;
}

/* Directional "Next"/"Previous" step-wizard icons (NewPermit's stepper,
   the onboarding tutorial) are plain arrow glyphs — stylis-plugin-rtl mirrors
   CSS left/right properties, but not SVG icon artwork, so in RTL mode "Next"
   kept pointing right (toward where "Back" should be) instead of left.
   Opt-in via .rtl-flip-icon so unrelated icons (which may already have
   correct or state-dependent direction, e.g. the sidebar collapse chevron)
   aren't affected. */
html[dir="rtl"] .rtl-flip-icon {
  transform: scaleX(-1);
}

/* Nastaliq's tall ascenders get clipped inside the small outlined "default"
   color Chips used in the Status / Last Action / Changes columns. */
html[dir="rtl"] .MuiChip-root.MuiChip-outlined.MuiChip-sizeSmall.MuiChip-colorDefault.MuiChip-outlinedDefault {
  padding: 15px 20px !important;
}

/* Box-sizing reset (Tailwind preflight is disabled; add it manually) */
*,
*::before,
*::after {
  box-sizing: border-box;
}

input,
textarea,
select,
button {
  font-family: inherit;
  appearance: none;
}

/* Tailwind CSS v3 — base (CSS vars only, preflight=false skips element resets), components & utilities */
*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {
  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {
  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {
  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {
  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {
  .container {
    max-width: 1536px;
  }
}
/* --- Page Container --- */
/* --- Loading --- */
.\\!loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding-top: 4rem;
  padding-bottom: 4rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  text-align: center;
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding-top: 4rem;
  padding-bottom: 4rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  text-align: center;
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
/* --- Messages --- */
.message {
  margin-bottom: 1.5rem;
}
@keyframes slideDown {
  0% {
    opacity: 0;
    transform: translateY(-10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.message {
  animation: slideDown 0.3s cubic-bezier(0.4,0,0.2,1) both;
  border-radius: 0.75rem;
  border-width: 1px;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
}
.message.success {
  --tw-border-opacity: 1;
  border-color: rgb(187 247 208 / var(--tw-border-opacity, 1));
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
  --tw-gradient-from: #f0fdf4 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(240 253 244 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: #dcfce7 var(--tw-gradient-to-position);
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}
.message.error {
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
  --tw-gradient-from: #fef2f2 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(254 242 242 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: #fee2e2 var(--tw-gradient-to-position);
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.message.\\!error {
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
  --tw-gradient-from: #fef2f2 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(254 242 242 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: #fee2e2 var(--tw-gradient-to-position);
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.message.info {
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
  --tw-gradient-from: #eff6ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 246 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: #dbeafe var(--tw-gradient-to-position);
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}
.message.warning {
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
  --tw-gradient-from: #fffbeb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 251 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: #fef3c7 var(--tw-gradient-to-position);
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity, 1));
}
/* --- Stats Grid --- */
.stat-card.\\!active {
    background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  }
.stat-card.active {
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  }
.stat-card.inactive {
    background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  }
.stat-card.pending {
    background: linear-gradient(135deg, #06b6d4 0%, #0891b2 100%);
  }
.stat-card.cancelled {
    background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  }
.stat-card.expired {
    background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
  }
/* --- Filter Section --- */
/* --- Table --- */
.permits-table .status {
  display: inline-block;
  border-radius: 0.5rem;
  padding-left: 0.875rem;
  padding-right: 0.875rem;
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 600;
  text-transform: capitalize;
}
.permits-table .status.active {
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(110 231 183 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(6 95 70 / var(--tw-text-opacity, 1));
}
.permits-table .status.\\!active {
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(110 231 183 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(6 95 70 / var(--tw-text-opacity, 1));
}
.permits-table .status.inactive {
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(252 211 77 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(120 53 15 / var(--tw-text-opacity, 1));
}
.permits-table .status.pending {
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(103 232 249 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(207 250 254 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(22 78 99 / var(--tw-text-opacity, 1));
}
.permits-table .status.cancelled {
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}
.permits-table .status.expired {
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(196 181 253 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(237 233 254 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(76 29 149 / var(--tw-text-opacity, 1));
}
/* --- Buttons --- */
/* --- Form --- */
/* ===== RoleManagement.css ===== */
.stat {
  text-align: center;
}
.alert {
  margin-bottom: 1.25rem;
}
@keyframes slideDown {
  0% {
    opacity: 0;
    transform: translateY(-10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.alert {
  animation: slideDown 0.3s cubic-bezier(0.4,0,0.2,1) both;
  border-radius: 0.75rem;
  border-width: 1px;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.visible {
  visibility: visible;
}
.collapse {
  visibility: collapse;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.right-3 {
  right: 0.75rem;
}
.top-1\\/2 {
  top: 50%;
}
.z-10 {
  z-index: 10;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.h-0\\.5 {
  height: 0.125rem;
}
.h-16 {
  height: 4rem;
}
.h-8 {
  height: 2rem;
}
.min-h-full {
  min-height: 100%;
}
.w-10 {
  width: 2.5rem;
}
.w-16 {
  width: 4rem;
}
.w-8 {
  width: 2rem;
}
.w-full {
  width: 100%;
}
.max-w-md {
  max-width: 28rem;
}
.flex-1 {
  flex: 1 1;
}
.shrink {
  flex-shrink: 1;
}
.border-collapse {
  border-collapse: collapse;
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: scale(0.9);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
.animate-fade-in {
  animation: fadeIn 0.6s ease-out 0.2s both;
}
@keyframes slideDown {
  0% {
    opacity: 0;
    transform: translateY(-10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.animate-slide-down {
  animation: slideDown 0.3s cubic-bezier(0.4,0,0.2,1) both;
}
@keyframes slideUp {
  0% {
    opacity: 0;
    transform: translateY(40px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.animate-slide-up {
  animation: slideUp 0.4s cubic-bezier(0.4,0,0.2,1) both;
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.flex-col {
  flex-direction: column;
}
.items-center {
  align-items: center;
}
.justify-center {
  justify-content: center;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-y-auto {
  overflow-y: auto;
}
.break-all {
  word-break: break-all;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-t {
  border-top-width: 1px;
}
.border-blue-200 {
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}
.border-green-200 {
  --tw-border-opacity: 1;
  border-color: rgb(187 247 208 / var(--tw-border-opacity, 1));
}
.border-red-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-slate-100 {
  --tw-border-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-border-opacity, 1));
}
.border-slate-200 {
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
.border-white\\/10 {
  border-color: rgb(255 255 255 / 0.1);
}
.bg-blue-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-green-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.bg-green-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity, 1));
}
.bg-green-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.bg-green-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
.bg-red-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.bg-slate-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.bg-slate-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}
.bg-slate-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.bg-slate-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.from-\\[\\#0f172a\\] {
  --tw-gradient-from: #0f172a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(15 23 42 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-900 {
  --tw-gradient-from: #0f172a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(15 23 42 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-\\[\\#1e293b\\] {
  --tw-gradient-to: #1e293b var(--tw-gradient-to-position);
}
.to-slate-700 {
  --tw-gradient-to: #334155 var(--tw-gradient-to-position);
}
.p-0 {
  padding: 0px;
}
.p-3 {
  padding: 0.75rem;
}
.p-5 {
  padding: 1.25rem;
}
.px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.pr-11 {
  padding-right: 2.75rem;
}
.pr-12 {
  padding-right: 3rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.text-center {
  text-align: center;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-5xl {
  font-size: 3rem;
  line-height: 1;
}
.text-\\[1\\.75rem\\] {
  font-size: 1.75rem;
}
.text-\\[15px\\] {
  font-size: 15px;
}
.text-\\[2rem\\] {
  font-size: 2rem;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.lowercase {
  text-transform: lowercase;
}
.capitalize {
  text-transform: capitalize;
}
.italic {
  font-style: italic;
}
.leading-none {
  line-height: 1;
}
.leading-relaxed {
  line-height: 1.625;
}
.tracking-\\[0\\.5em\\] {
  letter-spacing: 0.5em;
}
.tracking-tight {
  letter-spacing: -0.025em;
}
.text-blue-700 {
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-green-800 {
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-red-700 {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.text-slate-400 {
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.text-slate-500 {
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.text-slate-600 {
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
.text-slate-700 {
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.text-slate-800 {
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
}
.text-slate-900 {
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.underline {
  text-decoration-line: underline;
}
.overline {
  text-decoration-line: overline;
}
.no-underline {
  text-decoration-line: none;
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

/* ============================================================
   Tailwind @layer components — replaces page.css, Auth.css
   so no per-page CSS file imports are needed.
   ============================================================ */

/* ===== Splash screen keyframes (must be outside @layer) ===== */
@keyframes splashFadeOut {
  from {
    opacity: 1;
    visibility: visible;
  }

  to {
    opacity: 0;
    visibility: hidden;
  }
}

@keyframes splashZoomIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes splashSlideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes splashPulse {

  0%,
  100% {
    opacity: 0.4;
    transform: scale(1);
  }

  50% {
    opacity: 1;
    transform: scale(1.2);
  }
}

@keyframes splashTextIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.splash-container {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%);
  z-index: 9999;
  animation: splashFadeOut 0.5s ease-in forwards 2.2s;
}

.splash-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 24px;
  animation: splashZoomIn 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.splash-lottie-wrapper {
  width: 300px;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.splash-title {
  font-size: 2.5rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  margin: 0;
  background: linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: splashSlideUp 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) 0.2s both;
}

.splash-subtitle {
  color: #cbd5e1;
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: 0.05em;
  margin: 0;
  animation: splashSlideUp 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) 0.4s both;
}

.splash-loader {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  animation: splashSlideUp 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) 0.6s both;
}

.splash-loader .dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #3b82f6;
  box-shadow: 0 0 10px rgba(59, 130, 246, 0.6);
  animation: splashPulse 1.4s infinite;
}

.splash-loader .dot:nth-child(2) {
  animation-delay: 0.2s;
}

.splash-loader .dot:nth-child(3) {
  animation-delay: 0.4s;
}

.splash-version {
  color: #94a3b8;
  font-size: 0.75rem;
  letter-spacing: 0.1em;
  margin: 0;
  animation: splashTextIn 1s ease-in 1s both;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f8fafc;
  color: #1e293b;
  line-height: 1.6;
}

/* Typography Scale */
h1 {
  font-size: 2.5rem;
  font-weight: 700;
  letter-spacing: -0.02em;
}

h2 {
  font-size: 2rem;
  font-weight: 700;
  letter-spacing: -0.01em;
}

h3 {
  font-size: 1.5rem;
  font-weight: 600;
  letter-spacing: -0.01em;
}

h4 {
  font-size: 1.25rem;
  font-weight: 600;
}

h5 {
  font-size: 1.125rem;
  font-weight: 600;
}

h6 {
  font-size: 1rem;
  font-weight: 600;
}

p {
  font-size: 0.95rem;
  color: #475569;
}

code {
  font-family: 'Fira Code', 'Monaco', 'Courier New', monospace;
  background-color: #f1f5f9;
  padding: 0.2em 0.4em;
  border-radius: 0.25rem;
  font-size: 0.9em;
}

.placeholder\\:text-slate-400::placeholder {
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}

.hover\\:-translate-y-0\\.5:hover {
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:border-slate-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}

.hover\\:bg-slate-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}

.hover\\:text-slate-600:hover {
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}

.hover\\:text-slate-700:hover {
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}

.hover\\:underline:hover {
  text-decoration-line: underline;
}

.hover\\:shadow-xl:hover {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.focus\\:border-slate-900:focus {
  --tw-border-opacity: 1;
  border-color: rgb(15 23 42 / var(--tw-border-opacity, 1));
}

.focus\\:bg-white:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-4:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-slate-900\\/10:focus {
  --tw-ring-color: rgb(15 23 42 / 0.1);
}

.active\\:translate-y-0:active {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}

.disabled\\:bg-slate-100:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}

.disabled\\:text-slate-400:disabled {
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}

.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}

.disabled\\:opacity-70:disabled {
  opacity: 0.7;
}

@media (min-width: 640px) {
  .sm\\:p-5 {
    padding: 1.25rem;
  }
  .sm\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .sm\\:py-12 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;kFACkF;AAClF;EACE,iCAAiC;EACjC,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,4DAAyE;EACzE;mFACiF;AACnF;;AAEA;;sFAEsF;AACtF;EACE;;yBAEuB;AACzB;;AAEA;;;;;;;;uEAQuE;AACvE;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,iCAAiC;EACjC,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;;;;4BAI4B;AAC5B;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;;;;wBAIwB;AACxB;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;;;;;;;kEAOkE;AAClE;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;;;;;qBAMqB;AACrB;EACE,qBAAqB;AACvB;;AAEA;oEACoE;AACpE;EACE,6BAA6B;AAC/B;;AAEA,uEAAuE;AACvE;;;EAGE,sBAAsB;AACxB;;AAEA;;;;EAIE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,yGAAyG;AACzG;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AASlB,2BAA2B;AAa3B,oBAAoB;AAElB;EAAA,aAAuF;EAAvF,sBAAuF;EAAvF,mBAAuF;EAAvF,SAAuF;EAAvF,iBAAuF;EAAvF,oBAAuF;EAAvF,qBAAuF;EAAvF,sBAAuF;EAAvF,kBAAuF;EAAvF,eAAuF;EAAvF,mBAAuF;EAAvF,oBAAuF;EAAvF;AAAuF;AAAvF;EAAA,aAAuF;EAAvF,sBAAuF;EAAvF,mBAAuF;EAAvF,SAAuF;EAAvF,iBAAuF;EAAvF,oBAAuF;EAAvF,qBAAuF;EAAvF,sBAAuF;EAAvF,kBAAuF;EAAvF,eAAuF;EAAvF,mBAAuF;EAAvF,oBAAuF;EAAvF;AAAuF;AAGzF,qBAAqB;AAUnB;EAAA;AAAgF;AAAhF;EAAA;IAAA,UAAgF;IAAhF;EAAgF;EAAhF;IAAA,UAAgF;IAAhF;EAAgF;AAAA;AAAhF;EAAA,wDAAgF;EAAhF,sBAAgF;EAAhF,iBAAgF;EAAhF,kBAAgF;EAAhF,mBAAgF;EAAhF,qBAAgF;EAAhF,wBAAgF;EAAhF,mBAAgF;EAAhF,oBAAgF;EAAhF;AAAgF;AAIhF;EAAA,sBAAmF;EAAnF,4DAAmF;EAAnF,4EAAmF;EAAnF,4DAAmF;EAAnF,qEAAmF;EAAnF,mEAAmF;EAAnF,wDAAmF;EAAnF,oBAAmF;EAAnF;AAAmF;AAInF;EAAA,sBAA2E;EAA3E,4DAA2E;EAA3E,4EAA2E;EAA3E,4DAA2E;EAA3E,qEAA2E;EAA3E,mEAA2E;EAA3E,wDAA2E;EAA3E,oBAA2E;EAA3E;AAA2E;AAA3E;EAAA,sBAA2E;EAA3E,4DAA2E;EAA3E,4EAA2E;EAA3E,4DAA2E;EAA3E,qEAA2E;EAA3E,mEAA2E;EAA3E,wDAA2E;EAA3E,oBAA2E;EAA3E;AAA2E;AAI3E;EAAA,sBAA+E;EAA/E,4DAA+E;EAA/E,4EAA+E;EAA/E,4DAA+E;EAA/E,qEAA+E;EAA/E,mEAA+E;EAA/E,wDAA+E;EAA/E,oBAA+E;EAA/E;AAA+E;AAI/E;EAAA,sBAAmF;EAAnF,4DAAmF;EAAnF,4EAAmF;EAAnF,4DAAmF;EAAnF,qEAAmF;EAAnF,mEAAmF;EAAnF,wDAAmF;EAAnF,oBAAmF;EAAnF;AAAmF;AAGrF,uBAAuB;AAevB;IACE,wEAA6D;EAC/D;AAFA;IACE,6DAA6D;EAC/D;AAEA;IACE,6DAA6D;EAC/D;AAEA;IACE,6DAA6D;EAC/D;AAEA;IACE,6DAA6D;EAC/D;AAEA;IACE,6DAA6D;EAC/D;AAcA,2BAA2B;AAa3B,kBAAkB;AA2BhB;EAAA,qBAA6E;EAA7E,qBAA6E;EAA7E,sBAA6E;EAA7E,uBAA6E;EAA7E,qBAA6E;EAA7E,wBAA6E;EAA7E,kBAA6E;EAA7E,iBAA6E;EAA7E,gBAA6E;EAA7E;AAA6E;AAI7E;EAAA,iBAAgE;EAAhE,sBAAgE;EAAhE,4DAAgE;EAAhE,kBAAgE;EAAhE,4DAAgE;EAAhE,oBAAgE;EAAhE;AAAgE;AAAhE;EAAA,iBAAgE;EAAhE,sBAAgE;EAAhE,4DAAgE;EAAhE,kBAAgE;EAAhE,4DAAgE;EAAhE,oBAAgE;EAAhE;AAAgE;AAIhE;EAAA,iBAA0D;EAA1D,sBAA0D;EAA1D,2DAA0D;EAA1D,kBAA0D;EAA1D,4DAA0D;EAA1D,oBAA0D;EAA1D;AAA0D;AAI1D;EAAA,iBAAuD;EAAvD,sBAAuD;EAAvD,4DAAuD;EAAvD,kBAAuD;EAAvD,4DAAuD;EAAvD,oBAAuD;EAAvD;AAAuD;AAIvD;EAAA,iBAAoD;EAApD,sBAAoD;EAApD,4DAAoD;EAApD,kBAAoD;EAApD,4DAAoD;EAApD,oBAAoD;EAApD;AAAoD;AAIpD;EAAA,iBAA6D;EAA7D,sBAA6D;EAA7D,4DAA6D;EAA7D,kBAA6D;EAA7D,4DAA6D;EAA7D,oBAA6D;EAA7D;AAA6D;AAG/D,oBAAoB;AA4CpB,iBAAiB;AAmDjB,mCAAmC;AAgDjC;EAAA;AAAkB;AAkGlB;EAAA;AAAoE;AAApE;EAAA;IAAA,UAAoE;IAApE;EAAoE;EAApE;IAAA,UAAoE;IAApE;EAAoE;AAAA;AAApE;EAAA,wDAAoE;EAApE,sBAAoE;EAApE,iBAAoE;EAApE,kBAAoE;EAApE,mBAAoE;EAApE,qBAAoE;EAApE,wBAAoE;EAApE,mBAAoE;EAApE;AAAoE;AAtZxE;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA,UAAmB;IAAnB;EAAmB;EAAnB;IAAA,UAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA,UAAmB;IAAnB;EAAmB;EAAnB;IAAA,UAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA,UAAmB;IAAnB;EAAmB;EAAnB;IAAA,UAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;;;iEAGiE;;AA8ZjE,iEAAiE;AACjE;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;EAEE;;IAEE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,0EAA0E;EAC1E,aAAa;EACb,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,8DAA8D;AAChE;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,yEAAyE;AAC3E;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;EACT,yEAAyE;AAC3E;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;EACvB,yEAAyE;AAC3E;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;EAC5C,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,SAAS;EACT,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,4DAA4D;EAC5D,yBAAyB;EACzB,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;AAClB;;AAtuBA;EAAA,oBAsuBC;EAtuBD;AAsuBC;;AAtuBD;EAAA,2BAsuBC;EAtuBD;AAsuBC;;AAtuBD;EAAA,sBAsuBC;EAtuBD;AAsuBC;;AAtuBD;EAAA,kBAsuBC;EAtuBD;AAsuBC;;AAtuBD;EAAA,oBAsuBC;EAtuBD;AAsuBC;;AAtuBD;EAAA,oBAsuBC;EAtuBD;AAsuBC;;AAtuBD;EAAA;AAsuBC;;AAtuBD;EAAA,gFAsuBC;EAtuBD,oGAsuBC;EAtuBD;AAsuBC;;AAtuBD;EAAA,sBAsuBC;EAtuBD;AAsuBC;;AAtuBD;EAAA,kBAsuBC;EAtuBD;AAsuBC;;AAtuBD;EAAA,8BAsuBC;EAtuBD;AAsuBC;;AAtuBD;EAAA,2GAsuBC;EAtuBD,yGAsuBC;EAtuBD;AAsuBC;;AAtuBD;EAAA;AAsuBC;;AAtuBD;EAAA,qBAsuBC;EAtuBD;AAsuBC;;AAtuBD;EAAA;AAsuBC;;AAtuBD;EAAA,kBAsuBC;EAtuBD;AAsuBC;;AAtuBD;EAAA,oBAsuBC;EAtuBD;AAsuBC;;AAtuBD;EAAA;AAsuBC;;AAtuBD;EAAA;AAsuBC;;AAtuBD;EAAA;IAAA;EAsuBC;EAtuBD;IAAA,oBAsuBC;IAtuBD;EAsuBC;EAtuBD;IAAA,iBAsuBC;IAtuBD;EAsuBC;AAAA","sourcesContent":["/* Noto Nastaliq Urdu — self-hosted (SIL Open Font License, see src/assets/fonts/OFL.txt).\n   Applied only in Urdu mode via the dir=\"rtl\" attribute i18n.js sets on <html>. */\n@font-face {\n  font-family: 'Noto Nastaliq Urdu';\n  font-style: normal;\n  font-weight: 400 700;\n  font-display: swap;\n  src: url('./assets/fonts/NotoNastaliqUrdu-Regular.woff2') format('woff2');\n  unicode-range: U+0600-06FF, U+0750-077F, U+0870-088E, U+0890-0891, U+0897-08E1, U+08E3-08FF,\n    U+200C-200E, U+2010-2011, U+204F, U+2E41, U+FB50-FDFF, U+FE70-FE74, U+FE76-FEFC;\n}\n\n/* MUI sets font-family per-component with class-selector specificity, so a plain\n   inherited rule here would lose that tie unpredictably by stylesheet order —\n   !important guarantees Urdu mode always wins, scoped so English mode is untouched. */\nhtml[dir=\"rtl\"] * {\n  font-family: 'Noto Nastaliq Urdu', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI',\n    'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif !important;\n}\n\n/* Nastaliq's tall ascenders get clipped inside small Chips — not by the\n   Chip's own padding, but by its inner .MuiChip-label span, which MUI gives\n   `overflow: hidden; white-space: nowrap` by default for text truncation.\n   Padding here is matched to MUI's default small Button (4px 10px) — the\n   \"تفصیلات\" button in the Actions column, which was never clipped and looks\n   right — so every chip in the row ends up the same visual size as that\n   reference instead of a mix of oversized/undersized pills. Opt-in via\n   .nastaliq-chip-padding (added only to the specific Chips that showed\n   clipping in PermitList.js) so other Chips elsewhere are untouched. */\nhtml[dir=\"rtl\"] .nastaliq-chip-padding {\n  padding: 4px 10px !important;\n  height: 32px !important;\n  box-sizing: border-box !important;\n  display: inline-flex !important;\n  align-items: center !important;\n}\n\n/* Chips with a leading icon (e.g. the History clock icon) otherwise end up\n   visibly bigger than plain-text chips because MUI adds its own icon margin\n   on top of our padding — tighten that margin so icon vs. no-icon chips\n   match. Height is locked above so content (icon or not) can no longer\n   change the chip's size. */\nhtml[dir=\"rtl\"] .nastaliq-chip-padding .MuiChip-icon {\n  margin-inline: 4px !important;\n  font-size: 1.1rem !important;\n}\n\nhtml[dir=\"rtl\"] .nastaliq-chip-padding .MuiChip-label {\n  overflow: visible !important;\n  white-space: nowrap !important;\n  line-height: 1.8 !important;\n  padding: 0 !important;\n}\n\n/* Same root cause as the Chip fix above, but for MUI TextField/Select\n   floating labels (the small caption above each filter dropdown) — MUI\n   clips them with `overflow: hidden` by default, cutting Nastaliq's tall\n   ascenders. Applied app-wide in RTL mode since every TextField label uses\n   the same structure. */\nhtml[dir=\"rtl\"] .MuiInputLabel-root {\n  overflow: visible !important;\n  line-height: 1.6 !important;\n}\n\n/* Same root cause again, this time for chart card titles (e.g. Reports.js's\n   CardHeader above each chart) — MUI's CardHeader title has tight default\n   line-height, and the tall Nastaliq ascenders poke out above the header's\n   own padding box. Since the header sits inside a Card with overflow:hidden\n   (for its rounded corners), that overflow area gets clipped instead of just\n   the header background, cropping the top of the Urdu heading. Extra\n   padding-top plus a taller line-height keeps the glyph fully inside the\n   header's own box so the Card's overflow never has to clip it. */\nhtml[dir=\"rtl\"] .MuiCardHeader-root {\n  padding-top: 16px !important;\n}\n\nhtml[dir=\"rtl\"] .MuiCardHeader-title {\n  line-height: 1.8 !important;\n}\n\n/* Directional \"Next\"/\"Previous\" step-wizard icons (NewPermit's stepper,\n   the onboarding tutorial) are plain arrow glyphs — stylis-plugin-rtl mirrors\n   CSS left/right properties, but not SVG icon artwork, so in RTL mode \"Next\"\n   kept pointing right (toward where \"Back\" should be) instead of left.\n   Opt-in via .rtl-flip-icon so unrelated icons (which may already have\n   correct or state-dependent direction, e.g. the sidebar collapse chevron)\n   aren't affected. */\nhtml[dir=\"rtl\"] .rtl-flip-icon {\n  transform: scaleX(-1);\n}\n\n/* Nastaliq's tall ascenders get clipped inside the small outlined \"default\"\n   color Chips used in the Status / Last Action / Changes columns. */\nhtml[dir=\"rtl\"] .MuiChip-root.MuiChip-outlined.MuiChip-sizeSmall.MuiChip-colorDefault.MuiChip-outlinedDefault {\n  padding: 15px 20px !important;\n}\n\n/* Box-sizing reset (Tailwind preflight is disabled; add it manually) */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\ninput,\ntextarea,\nselect,\nbutton {\n  font-family: inherit;\n  appearance: none;\n}\n\n/* Tailwind CSS v3 — base (CSS vars only, preflight=false skips element resets), components & utilities */\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/* ============================================================\n   Tailwind @layer components — replaces page.css, Auth.css\n   so no per-page CSS file imports are needed.\n   ============================================================ */\n@layer components {\n\n  /* --- Page Container --- */\n  .page-container {\n    @apply bg-white p-8 rounded-2xl shadow-sm border border-slate-200 w-full max-w-[1400px] mx-auto transition-shadow duration-300;\n  }\n\n  .page-container:hover {\n    @apply shadow-md;\n  }\n\n  .page-container h2 {\n    @apply text-slate-900 mb-7 border-b-2 border-slate-900 pb-4 text-[28px] font-bold tracking-tight;\n  }\n\n  /* --- Loading --- */\n  .loading {\n    @apply text-center py-16 px-5 text-base text-slate-500 flex flex-col items-center gap-4;\n  }\n\n  /* --- Messages --- */\n  .error-message {\n    @apply px-4 py-3.5 rounded-xl mb-5 border font-medium text-sm bg-gradient-to-br from-red-50 to-red-100 text-red-700 border-red-200 animate-slide-down;\n  }\n\n  .success-message {\n    @apply px-4 py-3.5 rounded-xl mb-5 border font-medium text-sm bg-gradient-to-br from-green-50 to-green-100 text-green-800 border-green-200 animate-slide-down;\n  }\n\n  .message {\n    @apply px-4 py-3.5 rounded-xl mb-6 border font-medium text-sm animate-slide-down;\n  }\n\n  .message.success {\n    @apply bg-gradient-to-br from-green-50 to-green-100 text-green-800 border-green-200;\n  }\n\n  .message.error {\n    @apply bg-gradient-to-br from-red-50 to-red-100 text-red-700 border-red-200;\n  }\n\n  .message.info {\n    @apply bg-gradient-to-br from-blue-50 to-blue-100 text-blue-800 border-blue-200;\n  }\n\n  .message.warning {\n    @apply bg-gradient-to-br from-amber-50 to-amber-100 text-amber-800 border-amber-200;\n  }\n\n  /* --- Stats Grid --- */\n  .stats-grid {\n    @apply grid gap-6 my-8;\n    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  }\n\n  .stat-card {\n    @apply text-white p-8 rounded-2xl shadow-md text-center border border-white/10 transition-all duration-300 relative overflow-hidden;\n    background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);\n  }\n\n  .stat-card:hover {\n    @apply -translate-y-1 shadow-xl;\n  }\n\n  .stat-card.active {\n    background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  }\n\n  .stat-card.inactive {\n    background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);\n  }\n\n  .stat-card.pending {\n    background: linear-gradient(135deg, #06b6d4 0%, #0891b2 100%);\n  }\n\n  .stat-card.cancelled {\n    background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);\n  }\n\n  .stat-card.expired {\n    background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);\n  }\n\n  .stat-card h3 {\n    @apply mb-3 text-[15px] font-semibold opacity-90;\n  }\n\n  .stat-card .stat-number {\n    @apply text-5xl font-bold;\n  }\n\n  .stat-card .stat-percent {\n    @apply text-[13px] mt-2 opacity-90;\n  }\n\n  /* --- Filter Section --- */\n  .filter-section {\n    @apply mb-7 flex gap-4 items-center flex-wrap p-5 bg-slate-50 rounded-xl border border-slate-200;\n  }\n\n  .filter-section label {\n    @apply font-semibold text-slate-900 text-sm;\n  }\n\n  .filter-section select {\n    @apply px-4 py-2.5 border border-slate-200 rounded-xl text-[15px] cursor-pointer bg-white transition-all duration-200 font-medium text-slate-800 focus:outline-none focus:border-slate-900 focus:ring-4 focus:ring-slate-900/10;\n  }\n\n  /* --- Table --- */\n  .table-container {\n    @apply overflow-x-auto mt-7 rounded-xl border border-slate-200 shadow-sm;\n  }\n\n  .permits-table {\n    @apply w-full bg-white border-collapse;\n  }\n\n  .permits-table th {\n    @apply px-5 py-4 text-left font-bold text-sm text-white;\n    background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);\n  }\n\n  .permits-table td {\n    @apply px-5 py-4 border-b border-slate-200 text-[15px];\n  }\n\n  .permits-table tbody tr {\n    @apply transition-all duration-200;\n  }\n\n  .permits-table tbody tr:hover {\n    @apply bg-slate-50;\n  }\n\n  .permits-table .status {\n    @apply inline-block px-3.5 py-1.5 rounded-lg font-semibold text-xs capitalize;\n  }\n\n  .permits-table .status.active {\n    @apply bg-emerald-100 text-emerald-800 border border-emerald-300;\n  }\n\n  .permits-table .status.inactive {\n    @apply bg-amber-100 text-amber-900 border border-amber-300;\n  }\n\n  .permits-table .status.pending {\n    @apply bg-cyan-100 text-cyan-900 border border-cyan-300;\n  }\n\n  .permits-table .status.cancelled {\n    @apply bg-red-100 text-red-800 border border-red-300;\n  }\n\n  .permits-table .status.expired {\n    @apply bg-violet-100 text-violet-900 border border-violet-300;\n  }\n\n  /* --- Buttons --- */\n  .btn-small {\n    @apply px-4 py-2 mr-2 rounded-lg bg-gradient-to-br from-slate-900 to-slate-800 text-white cursor-pointer font-semibold text-[13px] transition-all duration-200 inline-flex items-center gap-1.5 shadow-sm;\n  }\n\n  .btn-small:not(:disabled):hover {\n    @apply -translate-y-0.5 shadow-md;\n  }\n\n  .btn-small:disabled {\n    @apply opacity-50 cursor-not-allowed;\n  }\n\n  .btn-primary {\n    @apply px-7 py-3 rounded-xl font-bold text-[15px] text-white shadow-md transition-all duration-200;\n    background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);\n  }\n\n  .btn-primary:not(:disabled):hover {\n    @apply -translate-y-0.5 shadow-lg;\n  }\n\n  .btn-primary:not(:disabled):active {\n    @apply translate-y-0;\n  }\n\n  .btn-primary:disabled {\n    @apply bg-slate-300 text-slate-400 cursor-not-allowed;\n  }\n\n  .btn-secondary,\n  .btn-cancel {\n    @apply px-7 py-3 rounded-xl font-bold text-[15px] text-slate-900 bg-slate-100 border border-slate-200 shadow-sm transition-all duration-200;\n  }\n\n  .btn-secondary:not(:disabled):hover,\n  .btn-cancel:not(:disabled):hover {\n    @apply bg-slate-200 border-slate-300 -translate-y-0.5 shadow-md;\n  }\n\n  .no-data {\n    @apply text-center text-slate-400 italic py-10 text-base;\n  }\n\n  /* --- Form --- */\n  .permit-form {\n    @apply bg-white p-8 rounded-2xl border border-slate-200 shadow-sm;\n  }\n\n  .form-row {\n    @apply grid gap-6 mb-6;\n    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  }\n\n  .form-group {\n    @apply flex flex-col gap-2;\n  }\n\n  .form-group.full-width {\n    grid-column: 1 / -1;\n  }\n\n  .form-group label {\n    @apply font-semibold text-slate-900 text-sm;\n  }\n\n  .form-group input,\n  .form-group select,\n  .form-group textarea {\n    @apply px-4 py-3 border border-slate-200 rounded-xl text-[15px] bg-slate-50 transition-all duration-200 placeholder:text-slate-400;\n    font-family: inherit;\n  }\n\n  .form-group input:hover,\n  .form-group select:hover,\n  .form-group textarea:hover {\n    @apply border-slate-300 bg-white;\n  }\n\n  .form-group input:focus,\n  .form-group select:focus,\n  .form-group textarea:focus {\n    @apply outline-none border-slate-900 bg-white ring-4 ring-slate-900/10;\n  }\n\n  .form-group input:disabled,\n  .form-group select:disabled,\n  .form-group textarea:disabled {\n    @apply bg-slate-100 text-slate-400 cursor-not-allowed border-slate-200;\n  }\n\n  .form-actions {\n    @apply flex gap-4 mt-8 flex-wrap;\n  }\n\n  /* ===== RoleManagement.css ===== */\n  .role-management {\n    @apply p-0 max-w-full m-0;\n  }\n\n  .management-header {\n    @apply mb-7 pb-4 border-b-2 border-slate-900;\n  }\n\n  .management-header h1 {\n    @apply text-slate-900 text-[32px] m-0 font-bold tracking-tight;\n  }\n\n  .roles-grid {\n    @apply grid gap-6 mb-10;\n    grid-template-columns: repeat(auto-fill, minmax(min(100%, 480px), 1fr));\n  }\n\n  .role-card {\n    @apply bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden transition-all duration-300;\n  }\n\n  .role-card:hover {\n    @apply shadow-xl -translate-y-1;\n  }\n\n  .role-header {\n    @apply p-6 text-white cursor-pointer flex justify-between items-start gap-5 transition-all duration-200;\n    background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);\n  }\n\n  .role-header:hover {\n    @apply opacity-95;\n  }\n\n  .role-header h3 {\n    @apply m-0 mb-2 text-xl font-bold tracking-tight;\n  }\n\n  .role-desc {\n    @apply m-0 text-sm opacity-85 font-medium;\n  }\n\n  .role-stats {\n    @apply flex gap-4;\n  }\n\n  .stat {\n    @apply text-center;\n  }\n\n  .stat-value {\n    @apply block text-[28px] font-bold leading-none;\n  }\n\n  .stat-label {\n    @apply block text-xs opacity-85 mt-1 font-semibold tracking-wide;\n  }\n\n  .role-content {\n    max-height: 0;\n    @apply overflow-hidden transition-all duration-300;\n  }\n\n  .role-content.expanded {\n    max-height: 600px;\n  }\n\n  .features-section {\n    @apply p-6 border-t border-slate-200 bg-slate-50;\n  }\n\n  .features-section h4 {\n    @apply m-0 mb-4 text-slate-900 text-[14px] uppercase tracking-widest font-bold;\n  }\n\n  .features-list {\n    @apply flex flex-col gap-2.5 mb-5;\n  }\n\n  .feature-item {\n    @apply flex justify-between items-center px-4 py-3 bg-white border border-slate-200 rounded-xl text-sm transition-all duration-200;\n  }\n\n  .feature-item:hover {\n    @apply border-slate-300 bg-slate-50;\n  }\n\n  .feature-name {\n    @apply text-slate-800 flex-1 font-medium;\n  }\n\n  .btn-remove {\n    @apply bg-transparent border-0 text-red-500 cursor-pointer text-base px-2 py-1 flex items-center justify-center rounded-md transition-all duration-200;\n  }\n\n  .btn-remove:hover {\n    @apply bg-red-50 text-red-600;\n  }\n\n  .no-features {\n    @apply text-slate-400 m-0 p-4 bg-white border border-dashed border-slate-300 rounded-xl text-center text-sm font-medium;\n  }\n\n  .add-feature {\n    @apply flex gap-3;\n  }\n\n  .feature-select {\n    @apply flex-1 px-4 py-2.5 border border-slate-200 rounded-xl text-[14px] cursor-pointer bg-white font-medium transition-all duration-200 focus:outline-none focus:border-slate-900 focus:ring-4 focus:ring-slate-900/10;\n  }\n\n  .role-info {\n    @apply bg-gradient-to-br from-slate-50 to-slate-100 p-8 rounded-2xl mt-10 border border-slate-200;\n  }\n\n  .role-info h3 {\n    @apply mt-0 mb-6 text-slate-900 text-[22px] font-bold;\n  }\n\n  .role-legend {\n    @apply grid gap-5;\n    grid-template-columns: repeat(auto-fit, minmax(min(100%, 320px), 1fr));\n  }\n\n  .legend-item {\n    @apply bg-white p-5 rounded-xl flex gap-4 items-start border-l-4 border-slate-900 shadow-sm;\n  }\n\n  .legend-color {\n    @apply w-6 h-6 rounded-lg flex-shrink-0 mt-0.5;\n  }\n\n  .legend-item strong {\n    @apply text-slate-900 text-[14px] font-bold;\n  }\n\n  .legend-item p {\n    @apply text-sm text-slate-500 leading-relaxed mt-2 mb-0;\n  }\n\n  .no-roles {\n    @apply col-span-full text-center py-16 px-5 text-slate-400 text-base;\n  }\n\n  .alert {\n    @apply px-4 py-3.5 rounded-xl mb-5 text-sm border animate-slide-down;\n  }\n\n  .alert-error {\n    @apply bg-gradient-to-br from-red-50 to-red-100 text-red-700 border-red-200;\n  }\n\n  .alert-success {\n    @apply bg-gradient-to-br from-green-50 to-green-100 text-green-800 border-green-200;\n  }\n\n}\n\n/* ===== Splash screen keyframes (must be outside @layer) ===== */\n@keyframes splashFadeOut {\n  from {\n    opacity: 1;\n    visibility: visible;\n  }\n\n  to {\n    opacity: 0;\n    visibility: hidden;\n  }\n}\n\n@keyframes splashZoomIn {\n  from {\n    opacity: 0;\n    transform: scale(0.8);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@keyframes splashSlideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes splashPulse {\n\n  0%,\n  100% {\n    opacity: 0.4;\n    transform: scale(1);\n  }\n\n  50% {\n    opacity: 1;\n    transform: scale(1.2);\n  }\n}\n\n@keyframes splashTextIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n.splash-container {\n  position: fixed;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  background: linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%);\n  z-index: 9999;\n  animation: splashFadeOut 0.5s ease-in forwards 2.2s;\n}\n\n.splash-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  gap: 24px;\n  animation: splashZoomIn 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n.splash-lottie-wrapper {\n  width: 300px;\n  height: 300px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.splash-title {\n  font-size: 2.5rem;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  margin: 0;\n  background: linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  animation: splashSlideUp 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) 0.2s both;\n}\n\n.splash-subtitle {\n  color: #cbd5e1;\n  font-size: 1rem;\n  font-weight: 500;\n  letter-spacing: 0.05em;\n  margin: 0;\n  animation: splashSlideUp 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) 0.4s both;\n}\n\n.splash-loader {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  justify-content: center;\n  animation: splashSlideUp 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) 0.6s both;\n}\n\n.splash-loader .dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #3b82f6;\n  box-shadow: 0 0 10px rgba(59, 130, 246, 0.6);\n  animation: splashPulse 1.4s infinite;\n}\n\n.splash-loader .dot:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n.splash-loader .dot:nth-child(3) {\n  animation-delay: 0.4s;\n}\n\n.splash-version {\n  color: #94a3b8;\n  font-size: 0.75rem;\n  letter-spacing: 0.1em;\n  margin: 0;\n  animation: splashTextIn 1s ease-in 1s both;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: #f8fafc;\n  color: #1e293b;\n  line-height: 1.6;\n}\n\n/* Typography Scale */\nh1 {\n  font-size: 2.5rem;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n}\n\nh2 {\n  font-size: 2rem;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n}\n\nh3 {\n  font-size: 1.5rem;\n  font-weight: 600;\n  letter-spacing: -0.01em;\n}\n\nh4 {\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n\nh5 {\n  font-size: 1.125rem;\n  font-weight: 600;\n}\n\nh6 {\n  font-size: 1rem;\n  font-weight: 600;\n}\n\np {\n  font-size: 0.95rem;\n  color: #475569;\n}\n\ncode {\n  font-family: 'Fira Code', 'Monaco', 'Courier New', monospace;\n  background-color: #f1f5f9;\n  padding: 0.2em 0.4em;\n  border-radius: 0.25rem;\n  font-size: 0.9em;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
